// @flow

import Service from "app/services/Service";

class FeedbackService extends Service {
    static base = "/";

    create(comment: string): Promise<*> {
        return this.http.post("/feedback", this.toSearchParams({ comment }));
    }
}

export default new FeedbackService();



// WEBPACK FOOTER //
// ./src/app/services/FeedbackService.js